const promoConfig = {
	enabled: false,
	interval: 1000 * 8,
	banners: [
		// {
		// 	id: 2,
		// 	url: '//www.lider-bet.com/ka/promotions/playVolt3',
		// 	animated: true,
		// },
		// {
		// 	id: 6,
		// 	url: '//www.lider-bet.com/ka/promotions/playVolt4',
		// 	animated: true,
		// },
		// {
		// 	id: 7,
		// 	url: '//www.lider-bet.com/ka/promotions/crash-games',
		// 	animated: true,
		// },
		{
			id: 8,
			url: '//www.lider-bet.com/ka/promotions/crash-games-leaderboard',
			animated: true,
		},
		// {
		// 	id: 9,
		// 	url: '//www.lider-bet.com/ka/promotions/digital-sport-stream-v4',
		// 	animated: true,
		// },
		// {
		// 	id: 10,
		// 	url: '//www.lider-bet.com/ka/promotions/volt-jetx',
		// 	animated: true,
		// },
		// {
		// 	id: 11,
		// 	url: '//www.lider-bet.com/ka/promotions/digital-sport-stream-v7',
		// 	animated: true,
		// },
		// {
		// 	id: 12,
		// 	url: '//www.lider-bet.com/ka/promotions/crash-games-cashback',
		// 	animated: true,
		// },
	],
}

export default promoConfig
